"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const SvgRange = props => (0, jsx_runtime_1.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  ...props,
  children: (0, jsx_runtime_1.jsxs)("g", {
    transform: "translate(1 1)",
    strokeWidth: 2,
    children: [(0, jsx_runtime_1.jsx)("circle", {
      "data-name": "Ellipse 25",
      cx: 8,
      cy: 8,
      r: 8,
      fill: "#fff",
      stroke: "#fff"
    }), (0, jsx_runtime_1.jsxs)("g", {
      "data-name": "Ellipse 27",
      transform: "translate(1 1)",
      fill: "none",
      stroke: "#2d5dec",
      children: [(0, jsx_runtime_1.jsx)("circle", {
        cx: 7,
        cy: 7,
        r: 7,
        stroke: "none"
      }), (0, jsx_runtime_1.jsx)("circle", {
        cx: 7,
        cy: 7,
        r: 6
      })]
    })]
  })
});
exports.default = SvgRange;